// @ts-ignore
import { useState } from "react";
import * as React from "react";

import Field from "./Field";
import {tr} from "../../helpers/Utils";
import ErrorAlert from "./ErrorAlert";
import Note from "./Note";

const ExtraWrapper = ({children, schema, visited, error, dispatcher, value}: any) => {
    const [openNotification, setOpenNotification] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);

    const errorText = visited && error?.message;
    let className = "default";
    if (value && !errorText) {
        className = "success";
    } else if (errorText) {
        className = "error";
    }
    return <Field {...schema} status={className}>
        {schema?.extra && schema.extra.hint && (
            <div className="alert alert-info hint" dangerouslySetInnerHTML={{ __html: schema.extra.hint }} />
        )}
        {children}
        {schema?.notification && openNotification && (
            <div
                className="alert alert-warning"
                role="alert"
                dangerouslySetInnerHTML={{ __html: tr(schema.notification) }}
            />
        )}
        {schema?.description && openInfo && (
            <div
                className="alert alert-warning"
                role="alert"
                dangerouslySetInnerHTML={{ __html: tr(schema.description) }}
            />
        )}
        <ErrorAlert errorMessage={errorText} />
        {schema?.extra && schema.extra.note && <Note content={schema.extra.note} dispatcher={dispatcher} />}
    </Field>;
};

export default ExtraWrapper;